import Common from '../../Common';

export interface CalendarScheduleBody {
	name?: string
	start: string
	end: string
	repeat?: string
	repeat_every?: string | null
	repeat_every_end?: string | null
	recurrence?: string | null
	force_pbx_destination_id?: string
}

const Schedule = class extends Common {
	browse = (calendarId: id): CustomResponse<CalenderSchedule[]> =>
		this.get(`/calendar/${calendarId}/schedules`)

	read = (calendarId: id, scheduleId: id): CustomResponse<CalenderSchedule> =>
		this.get(`/calendar/${calendarId}/schedule/${scheduleId}`)

	create = (calendarId: id, body: CalendarScheduleBody) =>
		this.post(`/calendar/${calendarId}/schedule`, body)

	update = (calendarId: id, scheduleId: id, body: Partial<CalendarScheduleBody>) =>
		this.patch(`/calendar/${calendarId}/schedule/${scheduleId}`, body)

	delete = (calendarId: id, scheduleId: id) =>
		super.doDelete(`/calendar/${calendarId}/schedule/${scheduleId}`)
}

export default Schedule;
